import template from './assetDetailsQuickQuote.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    quickQuoteAssetDetails: '<',
    quickQuoteFinanceProposal: '<',
    quickQuoteSearchFields: '<',
    quickQuoteSelectedProduct: '<',
    lenders: '<',
    idTicket: '<',
    isCommercial: '<',
    isQuickQuoteUnsecured: '<',
    isTicketSettled: '<',
    onResetListOfSearchProducts: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdUtil,
      $mdMedia,
      eventService,
      AssetFinanceDetail,
      AssetFinanceProposal,
      helperService,
      assetFinanceService,
      changesService,
      financesService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableAssetAges = [];
      ctrl.availableAssetTypes = [];
      ctrl.availableCarTypes = [];
      ctrl.availableYears = [];
      ctrl.availableVendorTypes = [];
      ctrl.otherDateFormat = $rootScope.CurrentDateFormatSecondary();
      ctrl.dateFormat = helperService.setOtherDateFormat;
      ctrl.searchTerm = '';
      ctrl.assetDetailParams = {};
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableAssetAges = assetFinanceService.getAvailableAssetAges();
        ctrl.availableCarTypes = assetFinanceService.getAvailableCarTypes();
        ctrl.availableYears = helperService.getAvailableYears({ isTaxYear: false });
        ctrl.quickQuoteAssetDetails = ctrl.quickQuoteAssetDetails || [];
        ctrl.quickQuoteFinanceProposal = ctrl.quickQuoteFinanceProposal || {};
        ctrl.quickQuoteSearchFields = ctrl.quickQuoteSearchFields || {};
        ctrl.quickQuoteSelectedProduct = ctrl.quickQuoteSelectedProduct || [];
        ctrl.lenders =
          _.chain(ctrl.lenders).sortNatural('name').sortNatural('group').value() || [];
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isCommercial = ctrl.isCommercial || false;
        ctrl.isQuickQuoteUnsecured = ctrl.isQuickQuoteUnsecured || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableAssetTypes = assetFinanceService.getAvailableAssetTypes(
          ctrl.isCommercial,
          false
        );
        ctrl.availableVendorTypes = assetFinanceService.getAvailableVendorTypes({
          isSearch: false,
          isCommercial: ctrl.isCommercial
        });
        if (!ctrl.quickQuoteAssetDetails?.length && !ctrl.isQuickQuoteUnsecured) {
          ctrl.assetDetailsAdd();
        }
        if (
          !ctrl.quickQuoteFinanceProposal?.totalAssetCost ||
          !ctrl.quickQuoteFinanceProposal?.totalAssetNetCost
        ) {
          ctrl.isProcessing = true;
          ctrl.assetFinanceAssetDetailsEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.assetDetailsAdd = () => {
        if (!ctrl.isQuickQuoteUnsecured) {
          ctrl.quickQuoteAssetDetails = assetFinanceService.assetDetailsAdd({
            assetDetails: ctrl.quickQuoteAssetDetails
          });
        }
      };

      ctrl.assetDetailsDelete = (asset) => {
        helperService
          .deleteItem(ctrl.quickQuoteAssetDetails, asset, asset.getName(), 'Asset')
          .then((result) => {
            if (result) {
              ctrl.assetDetailChanges();
            }
          });
      };

      ctrl.assetDetailChange = ({ assetDetail, action }) => {
        ctrl.assetDetails = assetFinanceService.assetDetailChange({
          assetDetails: ctrl.quickQuoteAssetDetails,
          assetDetail,
          action,
          isCommercial: ctrl.isCommercial
        });
        ctrl.assetDetailChanges();
      };

      ctrl.assetDetailChanges = ({ assetDetail, action }) => {
        assetFinanceService
          .assetDetailChanges({
            assetDetails: ctrl.quickQuoteAssetDetails,
            assetDetail,
            action
          })
          .then((result) => {
            if (result.status) {
              ctrl.quickQuoteAssetDetails = result.assetDetails;
              ctrl.assetDetailChanges();
            }
          });
      };

      ctrl.toggleUnsecured = () => {
        if (ctrl.isQuickQuoteUnsecured) {
          ctrl.quickQuoteAssetDetails = [];
        } else {
          ctrl.assetDetailsAdd();
        }
        ctrl.assetDetailChanges();
      };

      ctrl.isLenderSelected = (asset) =>
        helperService.isLenderSelected({ lenders: ctrl.lenders, lender: asset?.trade?.lender });

      ctrl.showLeaseWarning = () =>
        ctrl.isCommercial &&
        (!assetFinanceService.canSelectLease(ctrl.quickQuoteAssetDetails) ||
          ctrl.isLeaseSelectedAsProductType());

      ctrl.isLeaseSelectedAsProductType = () =>
        assetFinanceService.isLeaseSelectedAsProductType({
          item: ctrl.quickQuoteFinanceProposal,
          isAssetDetails: true
        });

      ctrl.getAssetDetailById = ({ assetDetails, id }) =>
        _.find(assetDetails || [], (a) => a?.id === id);

      ctrl.assetFinanceAssetDetailsEstimate = () => {
        if (!ctrl.idTicket) {
          ctrl.assetDetailParams = {
            quickQuoteAssetDetails: ctrl.quickQuoteAssetDetails
          };
        }
        financesService
          .assetFinanceAssetDetails({
            idTicket: ctrl.idTicket || '',
            assetDetailParams: ctrl.assetDetailParams || {},
            isQuote: true
          })
          .then((res) => {
            if (res?.status) {
              const len = ctrl.quickQuoteAssetDetails?.length || 0;
              for (let a = 0; a < len; a += 1) {
                const quickQuoteAssetDetail = ctrl.quickQuoteAssetDetails[a];
                const resAssetDetail = ctrl.getAssetDetailById({
                  assetDetails: res?.assetDetails?.assetDetails || [],
                  id: quickQuoteAssetDetail?.id || ''
                });
                if (resAssetDetail) {
                  quickQuoteAssetDetail.calculatedDeposit =
                    resAssetDetail?.calculatedDeposit || 0;
                  quickQuoteAssetDetail.netCost = resAssetDetail?.netCost || 0;
                  quickQuoteAssetDetail.trade.balance = resAssetDetail?.tradeBalance || 0;
                }
              }
              ctrl.quickQuoteFinanceProposal.totalAssetCost =
                res?.assetDetails?.totalAssetCost || 0;
              ctrl.quickQuoteFinanceProposal.totalAssetNetCost =
                res?.assetDetails?.totalAssetNetCost || 0;
              if (!ctrl.quickQuoteSelectedProduct?.length) {
                if (!ctrl.quickQuoteFinanceProposal.isNetAmountFinancedEdited) {
                  ctrl.quickQuoteFinanceProposal.netAmountFinanced =
                    res?.assetDetails?.totalAssetNetCost || 0;
                  ctrl.quickQuoteFinanceProposal.loanAmount =
                    res?.assetDetails?.totalAssetNetCost || 0;
                }
                ctrl.quickQuoteFinanceProposal.balloonValue = assetFinanceService.setValueOrPercent(
                  {
                    amount: ctrl.quickQuoteFinanceProposal?.totalAssetCost || 0,
                    percent: ctrl.quickQuoteFinanceProposal?.balloonPercent || 0
                  }
                );
                if (ctrl.isCommercial) {
                  ctrl.quickQuoteFinanceProposal.brokerCommissionValue = assetFinanceService.setValueOrPercent(
                    {
                      amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                      percent: ctrl.quickQuoteFinanceProposal?.brokerCommissionPercent || 0
                    }
                  );
                }
                ctrl.quickQuoteSearchFields.lvrLvt = assetFinanceService.setLvrLvt({
                  amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                  total: ctrl.quickQuoteFinanceProposal.totalAssetCost || 0
                });
                const totalAssetCostInfo = _.reduce(
                  ctrl.quickQuoteAssetDetails || [],
                  (memo, num) => _.add(memo + _.toNumber(num?.costInfo || 0)),
                  0
                );
                ctrl.quickQuoteSearchFields.integrationLvrLvt = assetFinanceService.setLvrLvt({
                  amount: ctrl.quickQuoteFinanceProposal?.netAmountFinanced || 0,
                  total: totalAssetCostInfo || 0
                });
              }
            }
            eventService.assetFinanceQuickQuoteProcessing({ isProcessing: false });
          });
      };

      ctrl.assetDetailChanges = () => {
        if (!ctrl.quickQuoteSelectedProduct?.length) {
          ctrl.onResetListOfSearchProducts();
        }
        ctrl.aDChanges();
      };

      ctrl.aDChanges = _.debounce(() => {
        ctrl.saveQuickQuoteAssetDetails();
      }, 3000);

      ctrl.saveQuickQuoteAssetDetails = () => {
        eventService.assetFinanceQuickQuoteProcessing({ isProcessing: true });
        const data = {
          quickQuoteAssetDetails: ctrl.quickQuoteAssetDetails,
          quickQuoteFinanceProposal: ctrl.quickQuoteFinanceProposal,
          isQuickQuoteUnsecured: ctrl.isQuickQuoteUnsecured,
          aFCD: 'assetFinanceQuickQuoteAssetDetails'
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'assetFinanceQuickQuoteAssetDetails') {
          ctrl.assetFinanceAssetDetailsEstimate();
        }
      });

      ctrl.destroyProcessingWatch = eventService.onAssetFinanceQuickQuoteProcessing(
        (params) => {
          ctrl.isProcessing = params?.isProcessing || false;
        }
      );

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
        ctrl.destroyProcessingWatch();
      };
    }
  }
};
